import * as React from 'react';

interface ITextInputComponent
{
	/** Признак необходимости заполнения */
	IsRequired: boolean,

	/** Признак отключения */
	IsDisabled: boolean,

	/** Признак валидности */
	IsValid: boolean,

	/** Текст */
	Value: string,

	/** Название поля */
	Label: string,

	/** Подсказка поля */
	Placeholder: string,

	/** Текст ошибки */
	Error: string,

	/** Максимальная длина */
	MaxLength: number,

	/**
	 *  Функция, выполняемая при изменении значения инпута
	 *  @value value - измененное значение инпута
	 */
	OnChange: (value: string) => void,

	/**
	 *  Функция, выполняемая при валидации значения (если элемент не задизаблен)
	 */
	OnValidate?: () => boolean,

	/** Тип авто-подстановки */
	AutoComplete?: string | undefined
}

export const TextInputComponent: React.FC<ITextInputComponent> =
	(
		// входные параметры компонента
		{ IsRequired, IsDisabled, IsValid, Value, Label, Placeholder, Error, MaxLength, OnChange, OnValidate, AutoComplete }: ITextInputComponent
	) =>
	{
		// заворачиваем входные функции в CallBack
		const OnChangeCallback = React.useCallback((value: string) =>
		{
			OnChange(value);
			if (!IsDisabled && OnValidate) OnValidate();
		}, [OnChange, OnValidate, IsDisabled])

		return (
			<div className="input-text-block">
				<label className={(IsValid ? "" : "invalid") + (IsDisabled?" filled":"")}>
					<span className="label-title">{Label}&nbsp;{IsRequired && <span className="text-danger">*</span>}</span>
					<span className="form-text-block">
						<input
							type="text"
							className="form-text"
							placeholder={Placeholder}
							value={Value}
							disabled={IsDisabled}
							maxLength={MaxLength}
							autoComplete={AutoComplete}
							onChange={(event: React.SyntheticEvent) => OnChangeCallback((event.target as HTMLInputElement).value)}
						/>
					</span>
					<span className="mb-0 error-message text-danger">{Error}</span>
				</label>
			</div>
		)
	}
